import Styles from "./styles.module.css";
import JourneyCard from "./JourneyCard";
import ProgramModal from "./ProgramModal";
import { useState } from "react"
import useFetchProgramsHindi from "../../hooks/useFetchProgramsHindi";
import SkeletonGrid from "../../components/SkeletonLoader/SkeletonGrid";
import SkeletonLoader from "../../components/SkeletonLoader/SkeletonLoader";

const HindiDashboard = () => {
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [modalOpen, setModalOpen] = useState(false)

    const {data: programs, error} = useFetchProgramsHindi("https://api.evolveinc.in/api/v3/journeys/detail")
    console.log(programs);
    // const programs = [
    //     {
    //         "id": 31,
    //         "title": "Start loving your body more",
    //         "ju_label": "start-loving-your-body-more",
    //         "promo_text": "21 days",
    //         "description": "5-10 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20231208074415.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240422051829.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌻 Self-love"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 34,
    //                 "title": "Start loving your body more!",
    //                 "description": "Improve your self-esteem by changing your relationship with your body!\r\n\r\n👉🏽 Reflect on your relationship with your body\r\n👉🏽 Understand your triggers and thought patterns\r\n👉🏽 Learn to give your body the resources it needs",
    //                 "num_steps": 21,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "21 days",
    //         "mins": "5-10 mins"
    //     },
    //     {
    //         "id": 85,
    //         "title": "Manage anxiety in your life",
    //         "ju_label": "manage-anxiety-in-your-life",
    //         "promo_text": "7 days",
    //         "description": "7-10 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Premium",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20220404101512.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240422052101.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌻 Self-love"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 87,
    //                 "title": "Manage anxiety in your life",
    //                 "description": "Start this journey & manage anxiety better!\r\n\r\n👉🏽Understand ways to build resilience\r\n👉🏽Learn to be more positive & happy\r\n👉🏽Empower yourself with actionable tips",
    //                 "num_steps": 7,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "7 days",
    //         "mins": "7-10 mins"
    //     },
    //     {
    //         "id": 50,
    //         "title": "Explore your identity",
    //         "ju_label": "explore-your-identity",
    //         "promo_text": "2 sessions",
    //         "description": "10-15 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20221130143926.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240422054019.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌈 LGBTQIA+"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 52,
    //                 "title": "🌈 Explore your identity",
    //                 "description": "As the world moves past stereotypes on gender and sexual identity, we provide you a safe space to understand and explore your own identity!\r\n\r\n👉🏽 Reflect on yourself without judgement\r\n👉🏽 Understand gender and sexuality",
    //                 "num_steps": 2,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "2 sessions",
    //         "mins": "10-15 mins"
    //     },
    //     {
    //         "id": 89,
    //         "title": "Accept your authentic self",
    //         "ju_label": "accept-your-authentic-self",
    //         "promo_text": "2 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20221130143942.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240422060329.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌈 LGBTQIA+"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 91,
    //                 "title": "🌈 Accept & embrace yourself",
    //                 "description": "Accepting your own identity and being true to yourself is a key part of your personal growth. In this journey, you will:\r\n\r\n👉🏽 Learn to accept your authentic self with pride\r\n👉🏽 Let go of other people's opinions of you",
    //                 "num_steps": 2,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "2 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 163,
    //         "title": "Navigate life with ADHD",
    //         "ju_label": "navigate-life-with-adhd",
    //         "promo_text": "3 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20240628080957.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240628080959.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🧠 Neurodiversity"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 197,
    //                 "title": "Navigating life with ADHD",
    //                 "description": "Learn more about how ADHD can affect people & how you can navigate it. In this journey, we will:\r\n\r\n👉🏽 Understand ADHD & its differences\r\n👉🏽 Reflect on your own experiences\r\n👉🏽 Learn actionable self-care techniques",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 164,
    //         "title": "Dating with ADHD",
    //         "ju_label": "dating-with-adhd",
    //         "promo_text": "3 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20240628113148.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240628113150.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🧠 Neurodiversity",
    //             "❤️ Relationships"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 198,
    //                 "title": "Dating with ADHD",
    //                 "description": "Learn more about how ADHD can impact relationships in your life.\r\n\r\n👉🏽 Understand how ADHD is impacting your relationships\r\n👉🏽 Learn ways to strengthen your bond & build resilience",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 21,
    //         "title": "Create healthier relationships",
    //         "ju_label": "create-healthier-relationships",
    //         "promo_text": "3 sessions",
    //         "description": "5-10 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20250114060005.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240416064509.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "❤️ Relationships"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 24,
    //                 "title": "Create healthier relationships",
    //                 "description": "Whether you're single, married (or any status in between), this journey will help you:\r\n👉🏽 Pause & reflect on your love life\r\n👉🏽 Understand what you desire in your relationships & partner\r\n👉🏽 Discover your values, love language & more",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "5-10 mins"
    //     },
    //     {
    //         "id": 47,
    //         "title": "Coping with social anxiety",
    //         "ju_label": "coping-with-social-anxiety",
    //         "promo_text": "3 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Premium",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20231114105311.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240422052140.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "❤️ Relationships"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 49,
    //                 "title": "Cope with social anxiety",
    //                 "description": "Start this journey & cope with social anxiety!\r\n\r\n👉🏽Understand your triggers and safety anchors\r\n👉🏽Learn coping mechanisms backed by experts\r\n👉🏽Manage your social anxiety over time",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 186,
    //         "title": "Increase your energies",
    //         "ju_label": "increase-your-energies",
    //         "promo_text": "4 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20250403074203.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20250403074000.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌻 Self-love"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 220,
    //                 "title": "Increase your enegies",
    //                 "description": "",
    //                 "num_steps": 4,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "4 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 183,
    //         "title": "Relationships with an ADHD partner",
    //         "ju_label": "relationships-with-an-adhd-partner",
    //         "promo_text": "3 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20250321073002.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20250321073003.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🧠 Neurodiversity",
    //             "❤️ Relationships"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 217,
    //                 "title": "Relationship with an ADHD partner",
    //                 "description": ".",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 86,
    //         "title": "Homophobia & hate from loved ones",
    //         "ju_label": "homophobia-hate-from-loved-ones",
    //         "promo_text": "2 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20220408134331.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240422060436.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌈 LGBTQIA+"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 88,
    //                 "title": "🌈 Homophobia from loved ones",
    //                 "description": "If you've experienced some form of homophobia and reactions from close family & friends, you're not alone. This journey will help you:\r\n\r\n👉🏽 Reflect on homophobia in a safe space\r\n👉🏽 Understand ways to build resilience",
    //                 "num_steps": 2,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "2 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 15,
    //         "title": "Stop procrastinating",
    //         "ju_label": "stop-procrastinating",
    //         "promo_text": "5 sessions",
    //         "description": "5-10 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Premium",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20220304092217.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240422052219.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "💼 Work"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 17,
    //                 "title": "Stop procrastinating",
    //                 "description": "Start this journey today and never let procrastination stop you from your goals!\r\n👉🏽 Actionable concepts backed by science\r\n👉🏽 Bite-sized and interactive learning\r\n👉🏽 Designed with leading experts",
    //                 "num_steps": 5,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "5 sessions",
    //         "mins": "5-10 mins"
    //     },
    //     {
    //         "id": 165,
    //         "title": "Navigating PMDD",
    //         "ju_label": "navigating-pmdd",
    //         "promo_text": "3 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20241002102508.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20241002102510.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌸 Sexual health"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 199,
    //                 "title": "Navigating PMDD",
    //                 "description": ".",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 169,
    //         "title": "Performance anxiety around sex",
    //         "ju_label": "performance-anxiety-around-sex",
    //         "promo_text": "3 sessions",
    //         "description": "5-7 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20241109093958.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20241109094001.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌸 Sexual health"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 203,
    //                 "title": "Deal with performance anxiety",
    //                 "description": "",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "5-7 mins"
    //     },
    //     {
    //         "id": 168,
    //         "title": "Navigate guilt & shame around sex",
    //         "ju_label": "navigate-guilt-shame-around-sex",
    //         "promo_text": "3 sessions",
    //         "description": "7-10 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Free",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20241030130134.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20241030130136.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "🌻 Self-love",
    //             "🌸 Sexual health"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 202,
    //                 "title": "Guilt & shame around sex",
    //                 "description": "",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "7-10 mins"
    //     },
    //     {
    //         "id": 30,
    //         "title": "Change your attitude to failure",
    //         "ju_label": "change-your-attitude-to-failure",
    //         "promo_text": "3 sessions",
    //         "description": "5-10 mins",
    //         "ju_type": "Single",
    //         "ju_premium": "Premium",
    //         "num_days": 1,
    //         "thumb_image": "https://prod-assets.evolveinc.in/media/journey/thumb/20210806113521.webp",
    //         "cover_image": "https://prod-assets.evolveinc.in/media/journey/cover/20240422052255.webp",
    //         "ju_link": null,
    //         "problems": [
    //             "💼 Work"
    //         ],
    //         "techniques": [],
    //         "days": [
    //             {
    //                 "id": 33,
    //                 "title": "Change your attitude to failure",
    //                 "description": "Don't let failure hold you back from your goals and desires!\r\n\r\n👉🏽 Understand what's holding you back \r\n👉🏽 Learn key mindset changes to help you\r\n👉🏽 Build resilience to bounce back in your life",
    //                 "num_steps": 3,
    //                 "day_completed": "no",
    //                 "completed_steps": 0
    //             }
    //         ],
    //         "details": "v2",
    //         "sessions": "3 sessions",
    //         "mins": "5-10 mins"
    //     }]
    // console.log(programs)

    const handleCardClick = (program) => {
        setSelectedProgram(program);
        setModalOpen(true)
        
    };

    const closeModal = () => {
        setSelectedProgram(null)
        setModalOpen(false)
    }

    const loading = !programs || programs.length === 0;
    // console.log("loading: ", loading)

    return (
    <div className={Styles.ProgramDashboard}>
        <div style={{textAlign: "left", paddingLeft: "3%", paddingTop: "3%"}}>
            <h1 style={{fontFamily: "GothamRounded", fontWeight: "470"}}>प्रोग्राम्स</h1>
        </div>

        {modalOpen && selectedProgram && <ProgramModal open={modalOpen} program={selectedProgram} onClose={closeModal} isHindi={true}/>}
      
      {/* <div className={Styles.ProgramGrid}>
        {loading ? <SkeletonGrid /> : (programs).map((program) => (
            <JourneyCard key={program.id} program={program} onClick={handleCardClick}/>
        ))}
      </div> */}

      {loading ? (
            <div>
                <SkeletonGrid />
            </div>
        ) : (
            <div className={Styles.ProgramGrid}>
                {programs.map((program) => {
                    return( 
                        // <a
                        //     href={`/wellbeing?ic=${program.id}`}
                        //     target="_blank"
                        //     rel="noopener noreferrer"
                        //     className={Styles.LinkStyle} 
                        // >
                            
                        // </a>
                        <JourneyCard key={program.id} program={program} onClick={handleCardClick}/>
                    )
                })}
            </div>
        )}
    </div>
  );
};

export default HindiDashboard